// Sentinel that unlocks the free-text Textarea — must match exactly to keep the
// dialog's "Other" branch in sync with the cancellation dialog convention.
export const DECLINE_REASON_OTHER =
  "Others (type reason manually if not listed)";

export const PROFILE_UPDATE_DECLINE_REASONS = [
  "Insufficient documentation",
  "Document quality unclear / unreadable",
  "Documents don't match requested change",
  "Identity verification failed",
  "Suspicious activity",
  "Internal: Tech team testing",
  DECLINE_REASON_OTHER,
] as const;

export const PROFESSIONAL_CHANGE_DECLINE_REASONS = [
  "No alternative professional available",
  "User has been informed; no change required",
  "Request unclear — need more context",
  "User did not respond to outreach",
  "Existing professional addressed the concern",
  "Internal: Tech team testing",
  DECLINE_REASON_OTHER,
] as const;

export type ProfileUpdateDeclineReason =
  (typeof PROFILE_UPDATE_DECLINE_REASONS)[number];

export type ProfessionalChangeDeclineReason =
  (typeof PROFESSIONAL_CHANGE_DECLINE_REASONS)[number];
